<template>
  <div class="page">
    <div class="main-container">
      <div class="content">
        <div class="content-topic">
          <el-collapse v-model="activeNames">
            <el-collapse-item title="1.未认证回复不了信息吗？" name="1">
              <div class="item-content">
                <p>陌生约聊致力于打造最真实的单生男女交友社区，陌生约聊交友大数据显示完成真人认证、<span class="=red-text">交友宣言</span> 认证，消息回复率提升600%。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="2.为什么我不能语音速配？" name="2">
              <div class="item-content">
                <p>语音速配功能是需要您通过了真人认证后才开启的权限。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="3.实名认证信息可以修改吗？" name="3">
              <div class="item-content">
                <p>陌生约聊是真实的交友平台，提倡真诚交友，为保障交友的真实性，实名认证信息提交后，不可进行修改哦~</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="4.如何取消认证信息？" name="4">
              <div class="item-content">
                <p>陌生约聊是真实的交友平台，提倡真诚交友，为保障交友的真实性，建议用户真人、实名等认证使用，交到更多好友~</p>
                <div style="height: 10px"></div>
                <p>如您这边想将已认证信息取消，为了确保您的账号安全，需要确定您是账号所有者，请您向客服提供本人真实相关信息，请联系官方<span class="blue-text" @click="handleSpanClick('toCustomer')">在线客服</span>咨询</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="5.如何真人认证？" name="5">
              <div class="item-content">
                <p>点击<span class="blue-text" @click="handleSpanClick('toRealPerson')">真人认证</span>即可进入认证页面，请按照提示进行操作，提交后请耐心等待审核，审核时间一般在2小时内。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="6.真人认证为什么不通过？" name="6">
              <div class="item-content">
                <p>真人认证需提交高清且无遮挡的人脸照片进行认证的。提交的头像过于模糊，无法判断属于同一人是无法通过审核的。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="7.认证审核需要多久通过？" name="7">
              <div class="item-content">
                <p>真人认证提交后，进入AI智能+人工审核过程，请耐心等待审核。</p>
                <div style="height: 10px"></div>
                <p>一般2小时内会处理。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="8.实名认证怎么操作？" name="8">
              <div class="item-content">
                <p>点击实名认证即可进入认证页面，请按照提示进行操作，填写相应信息后进行身认证认证即可完成认证。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="9.实名认证不了怎么办？" name="9">
              <div class="item-content">
                <p>您好，如果您实名认证不了，建议您可以在实名认证下方点击联系客服，按要求提交手持身份证进行认证，提交后请耐心等待审核。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="10.我之前已经真人认证过，怎么没有了？" name="10">
              <div class="item-content">
                <p>真人认证系统会定期检查审核，有不符合的会被取消，建议您可以操作重新提交真人认证。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="11.语音认证怎么操作？" name="11">
              <div class="item-content">
                <p>点击编辑语音签名即可录制语音签名，提交后进入AI智能+人工审核过程。</p>
                <p>请耐心等待审核。</p>
                <p>一般2小时内会处理。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="12.语音签名认证怎么没通过？" name="12">
              <div class="item-content">
                <p>若提交的语音认证质量较低，并没有展现自身魅力，则会导致语音认证无法通过，您可以重新录制语音签名提交审核。建议录制:自己唱的一首歌/一段内心独白/交友宣言。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="13.怎么更新语音签名？" name="13" class="last">
              <div class="item-content">
                <p>点击<span class="blue-text" @click="handleSpanClick('toVoiceFlag')">编辑语音签名</span>即可录制新的语音签名。</p>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </div>
    <Service/>
  </div>
</template>

<script>
import Service from "./Service";
export default {
  name: 'Index',
  components: {Service},

  data() {
    return {
      activeNames: '',
    }
  },
  method: function () {
    window.showInfoFromJs = this.showInfoFromJs
  },
  methods: {
    goAddPage(route) {
      this.$router.push(route);
    },
    handleSpanClick(value) {
      var basePath = "<%=basePath%>";
      var browser = {
        versions: function () {
          var u = navigator.userAgent, app = navigator.appVersion;
          return {//移动终端浏览器版本信息
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
            iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('iPad') > -1, //是否iPad
          };
        }(),
        language: (navigator.browserLanguage || navigator.language).toLowerCase()
      };

      // 调用浏览器版本信息判断是IOS还是Android
      if (browser.versions.ios || browser.versions.iPhone || browser.versions.iPad) {
        window.webkit.messageHandlers.WebToiOS.postMessage(value);
      } else {
        this.showInfoFromJs(value);
      }
    },
    webToAndroid(value) {
      var basePath = "<%=basePath%>";
      var browser = {
        versions: function () {
          var u = navigator.userAgent, app = navigator.appVersion;
          return {//移动终端浏览器版本信息
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
            iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('iPad') > -1, //是否iPad
          };
        }(),
        language: (navigator.browserLanguage || navigator.language).toLowerCase()
      }

      //调用浏览器版本信息判断是IOS还是Android
      if (browser.versions.ios || browser.versions.iPhone || browser.versions.iPad) {
        window.webkit.messageHandlers.WebToiOS.postMessage(value);
      } else {
        this.showInfoFromJs(value)
      }
    },
    showInfoFromJs(value) {
      return window.AndroidWebView.showInfoFromJs(value);
    },
  }
}
</script>


<style scoped>

.icon-top {
  width: 100%;
  height: 143px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.icon-item {
  width: 80px;
  height: 102px;
  border-radius: 8px;
}

.hr {
  height: 12px;
  width: 100%;
  background: #F9FAFC;
}


.content {
  width: 100%;
}

.content-title {
  margin-top: 20px;
  margin-left: 12px;
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 600;
}


/deep/ .van-cell {
  color: #666666;
}

/deep/ .van-icon-circle2 {
  color:#3576F9;
}

/deep/ .van-icon-circle {
  color: #E6E5E5;
}

/deep/ .checked-title {
  font-size: 15px;
  color: #000000 !important;
}
/deep/ .unchecked {
  font-size: 15px;
}

.item-content {
  font-size: 13px;
  color: #333333;
  line-height: 20px;
  padding-left: 20px;
  padding-right: 20px;
}

.item-title {
  font-weight: 600;
}

.key-text{
  font-weight: 500;
  color: #4C30FC;
}

.item-img{
  width: 100%;
  text-align: center;
  margin-top: 30px;
}

/*.page {
  background-image: url("../assets/img/bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}*/
.customer-service {
  position: fixed;
  bottom: 30px;
  left: 80%;
  transform: translateX(-50%);
  width: 60px;
  height: 60px;
}

.customer-service img {
  width: 100%;
  height: 100%;
}

.red-text {
  color: red;
}

.blue-text {
  color: cornflowerblue;
}

.main-container{
  z-index: 999;
  position: relative;
  background-color: #f5f7fb;
  padding: 18px 18px 14px 18px;
}
.content .content-topic:last-child{
  margin-bottom: 70px;
}
.content-topic{
  padding: 0 13px;
  background-color: #ffffff;
  border-radius: 10px;
}
.content-topic .el-collapse {
  border-top: none;
  border-bottom: none;
}
.content-topic .el-collapse-item__header {
  font-size: 15px;
}
.content-topic .last .el-collapse-item__header {
  border-bottom: none;
}
</style>



// WEBPACK FOOTER //
// src/page/Certification.vue